/* The gateway PROXY base URL shown in docs snippets — what external clients
 * set as ANTHROPIC_BASE_URL. This is the public api-server endpoint that
 * authenticates the AI21 key and forwards to the coding gateway; it is NOT
 * the dashboard's own VITE_ANALYTICS_API_BASE (that is an internal mount root
 * the dashboard calls for analytics/admin data, on a different path — and
 * often a different host — than where coding agents send /v1/messages).
 *
 * So there is nothing reliable to derive: the proxy URL must be configured
 * explicitly via VITE_GATEWAY_BASE_URL. When unset, snippets fall back to a
 * documented placeholder, flagged so the docs tell readers to substitute
 * their own URL. */

import { readEnv } from "../analytics/config";

export const GATEWAY_URL_PLACEHOLDER = "https://gateway.example.com";

const configured = readEnv("VITE_GATEWAY_BASE_URL")?.replace(/\/+$/, "");

/** Base URL for docs snippets; the placeholder when nothing is configured. */
export const GATEWAY_BASE_URL = configured ?? GATEWAY_URL_PLACEHOLDER;

/** True ⇒ docs pages should tell the reader to substitute their own URL. */
export const GATEWAY_URL_IS_PLACEHOLDER = configured === undefined;
